import { render, staticRenderFns } from "./Umsatzwachstum.vue?vue&type=template&id=2aabe67c&"
import script from "./Umsatzwachstum.vue?vue&type=script&lang=ts&"
export * from "./Umsatzwachstum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports